import React, {
  forwardRef,
  useRef,
  useCallback,
  useMemo,
  useImperativeHandle,
} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { YoutubeEmbed } from 'src/components/YoutubeEmbed';
import { useCarouselData } from './useCarouselData';
import { useStyles } from './useStyles';

export const VideoCarousel = forwardRef(
  ({ className, currentVideo, videoIds, onChangeVideo }, ref) => {
    const styles = useStyles();
    const carouselRef = useRef();
    const childrenRef = useRef([]);

    const selectedIndex = useMemo(
      () => videoIds.findIndex((id) => id === currentVideo),
      [videoIds, currentVideo]
    );
    const { scrollToSelected } = useCarouselData({
      carouselRef,
      childrenRef,
      selectedIndex,
    });

    useImperativeHandle(ref, () => ({
      scrollToSelected,
    }));

    const handleClick = useCallback(
      (event, video) => {
        event.preventDefault();
        onChangeVideo(event, video);
      },
      [onChangeVideo]
    );

    return (
      <div className={cx(styles.root, className)}>
        <div className={styles.carousel} ref={carouselRef}>
          <div className={styles.track}>
            {videoIds.map((id, index) => (
              <div
                key={id}
                className={cx(styles.child, {
                  [styles.unselected]: index !== selectedIndex,
                })}
                onClick={(event) => {
                  handleClick(event, id);
                }}
                ref={(childRef) => {
                  childrenRef.current[index] = childRef;
                }}
              >
                <YoutubeEmbed
                  className={cx(styles.iframe)}
                  title="explainer video"
                  videoId={id}
                />
              </div>
            ))}
            <div className={cx(styles.child, styles.unselected)}>
              <div style={{ width: 780, height: 435 }} />
            </div>
          </div>
        </div>
      </div>
    );
  }
);

VideoCarousel.propTypes = {
  className: PropTypes.string,
  videoIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  currentVideo: PropTypes.string.isRequired,
  onChangeVideo: PropTypes.func.isRequired,
};

VideoCarousel.defaultProps = {
  className: null,
};
